import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { EmployeeInvitation, Res, UserInfo } from '../models';
import { ApiBasicService } from './api-basic.service';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ApiUsersService {

  userInfoSubject: Subject<UserInfo> = new Subject<UserInfo>();
  userInfo: UserInfo;

  constructor(
    private api: ApiService,
    private apiBasic: ApiBasicService
  ) { }


  /**
   * 
   * @returns Observable<UserInfo>
   */
  listenerUserInfo(): Observable<UserInfo> {

    return this.userInfoSubject.asObservable();
  }


  /**
   * 
   * @param params EmployeeInvitation
   * @returns Observable<Res>
   */
  sendInvitationToEmployee(params: EmployeeInvitation): Observable<Res> {

    return this.api.post('sendInvitation', params, 'private');
  }


  /**
   * 
   * @param value 
   */
  setUserInfo(value: UserInfo): void {

    this.userInfoSubject.next(value);
    this.userInfo = value;
  }


  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getList(params: any): Observable<Res> {

    return this.apiBasic.getList(params, 'orgs_users');
  }

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  getReferences(params: any, moduleName: string): Observable<Res> {

    return this.apiBasic.getReferences(params, moduleName);
  }


  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  info(): Observable<Res> {

    return this.apiBasic.getInfo('user');
  }


  /**
   * 
   * @param id string
   * @returns Observable<Res>
   */
  edit(id: string = ''): Observable<Res> {

    return this.apiBasic.edit('user', id);
  }
 

  /**
   * 
   * @param params any
   * @returns Observable<Res>
   */
  save(params: any): Observable<Res> {

    return this.apiBasic.create('user_account', params);
  }
 

  /**
* 
* @param params any
* @returns Observable<Res>
*/
  userPassworUpdate(params: any): Observable<Res> {

    return this.apiBasic.update('user_password', params);
  }

  /**
 * 
 * @param params any
 * @returns Observable<Res>
 */
  update(params: any): Observable<Res> {

    return this.apiBasic.update('user_account', params);
  }

  /**
  * 
  */
  delete(params: any): Observable<Res> {

    return this.apiBasic.delete('orgs_users', params);
  }

  /**
  * 
  */
  changeState(params: any, state): Observable<Res> {

    return this.apiBasic.changeUserState('orgs_users', params, state);
  }
}
